import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import {
  Add,
  Close,
  Check,
  Edit,
  Search,
  Settings,
  Tune,
} from "@mui/icons-material";
// import axiosClient from "@/lib/axios-client";
import axios from "axios";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { schooldetails } from './redux/schooldetails';
import { useTerminology } from './hooks/useTerminology';
import { getdata } from './redux/students';
import { getdata_ } from './redux/class';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

// Types (unchanged from original)
type AssessmentType = "assignment" | "exercise" | "test" | "exams score" | "assess toddlers" | "Class Score";

type AssessmentColumn = {
  id: string;
  name: string;
  type: AssessmentType;
  visible: boolean;
};

// Add toddler assessment types
type ToddlerRating = "Outstanding" | "Excellent" | "Very Good" | "Good" | "Satisfactory" | "Needs Improvement" | "Requires Support" | "Not Observed" | "Emerging" | "Developing";

type ToddlerAssessmentData = {
  rating: ToddlerRating;
  notes?: string;
  milestone?: string;
  category?: string;
};

type ScoreEntry = {
  studentId: string;
  subjectId: string;
  assessmentId: string;
  score: number;
  totalScore: number;
  toddlerData?: ToddlerAssessmentData; // Add toddler-specific data
};

type Student = {
  id: string;
  name: string;
};

type Subject = {
  id: string;
  name: string;
};

type GradeLevel = string;

type GradeRange = {
  remarks: GradeLevel;
  minScore: number;
  maxScore: number;
  color: string;
  gradepoint: number;
  gradeType: string;
};

type Remark = {
  studentId: string;
  subjectId: string;
  text: string;
};

type Term = {
  id: string;
  name: string;
};

type StudentRecord = {
  studentId: string;
  studentName: string;
  termId: string;
  subjects: SubjectRecord[];
  aggregateResults: {
    bestSixTotal: number;
    overallPosition: string;
    overallRemarks: string;
    attendanceScore: string;
  };
  domainAssessment?: any;
  classScale?: number;
  examScale?: number;
};

type SubjectRecord = {
  subjectId: string;
  subjectName: string;
  assessments: {
    id: string;
    type: AssessmentType;
    score: number;
    totalScore: number;
    toddlerData?: ToddlerAssessmentData; // Include toddler assessment data
  }[];
  classScore: number;
  examScore: number;
  totalScore: number;
  grade: string;
  position: string;
  remarks: string;
  gradeType?: string;
  gradePoint?: number;
  specialExamScore?: string; // For special exams: "obtained/total" format (e.g., "30/40")
};

// Sample data (unchanged)
const initialStudents: Student[] = [
  { id: "s1", name: "Alice Smith" },
  { id: "s2", name: "Bob Johnson" },
  { id: "s3", name: "Charlie Williams" },
];

const initialSubjects: Subject[] = [
  { id: "sub1", name: "English" },
  { id: "sub2", name: "Mathematics" },
  { id: "sub3", name: "Science" },
];

const initialAssessmentColumns: AssessmentColumn[] = [
  { id: "col1", name: "Class Score", type: "Class Score", visible: true },
  { id: "col2", name: "Exam Score", type: "exams score", visible: true },
];

// Helper function (unchanged)
const getOrdinalSuffix = (num: number): string => {
  const j = num % 10;
  const k = num % 100;
  if (j === 1 && k !== 11) return "st";
  if (j === 2 && k !== 12) return "nd";
  if (j === 3 && k !== 13) return "rd";
  return "th";
};

export default function StudentScoreCalculator(props) {
  // State declarations (unchanged)
  const dispatch = useDispatch()

  const studentlist: Student[] = [];
  const subjectlist: Subject[] = [];
  const termlist: Term[] = [];

  const adminData = useSelector((state: any) => state.admin);
  const stud = useSelector((state: any) => state.students)
  const Class_ = useSelector((state: any) => state.Class_)
  const currentClassData = useSelector((state: any) => state.Class_);
  
  // Get terminology and term options
  const { terminology, termOptions } = useTerminology();

  const schools = stud

  for (let i = 0; i < props.students.length; i++) {
    const student: Student = {
      id: props.students[i].ID,
      name: props.students[i].lastname + " " + props.students[i].othernames
    };
    studentlist.push(student);
  }

  for (let i = 0; i < (props.Class_.subjects && props.Class_.subjects[0] ? props.Class_.subjects[0].length : 0); i++) {
    const subject: Subject = {
      id: props.Class_.subjects[0][i].subject,
      name: props.Class_.subjects[0][i].subject
    };
    subjectlist.push(subject);
  }

  if (props.schooldata && props.schooldata.length > 0 && props.schooldata[0] && props.schooldata[0].terms && props.schooldata[0].terms.length > 0) {
    for (let i = 0; i < props.schooldata[0].terms.length; i++) {
      const term: Term = {
        id: props.schooldata[0].terms[i],
        name: props.schooldata[0].terms[i]
      };
      termlist.push(term);
    }
  }
  const [students, setStudents] = useState<Student[]>(studentlist);
  const [subjects, setSubjects] = useState<Subject[]>(subjectlist);
  const [assessmentColumns, setAssessmentColumns] = useState<AssessmentColumn[]>(initialAssessmentColumns);
  //sort all new academic recoreds and by term and put in total score, when submitting check to see if term exist and update it in mongo db

  // Map subjectId -> subject type (e.g. "Core", "Elective", "Special Exams")
  const subjectTypeMap = useMemo(() => {
    const map: Record<string, string> = {};

    if (props.Class_ && props.Class_.subjects && props.Class_.subjects[0]) {
      props.Class_.subjects[0].forEach((sub: any) => {
        if (sub && sub.subject !== undefined && sub.subject !== null) {
          const key = String(sub.subject).trim();
          map[key] = (sub.type || '').toLowerCase();
        }
      });
    }

    return map;
  }, [props.Class_]);

  // Helper function to check if a subject is a special exam
  const isSpecialExamSubject = useCallback((subjectId: string): boolean => {
    const type = subjectTypeMap[subjectId] || '';
    return type.toLowerCase().trim() === 'special exams' || type.toLowerCase().trim() === 'special exam';
  }, [subjectTypeMap]);

  const [scores, setScores] = useState<ScoreEntry[]>([]);
  // Special exam scores stored as "obtained/total" format (e.g., "30/40")
  const [specialExamScores, setSpecialExamScores] = useState<Record<string, string>>({});
  const [overallScaleValue, setOverallScaleValue] = useState<string>("100");
  const [classScaleValue, setClassScaleValue] = useState<string>("50");
  const [examScaleValue, setExamScaleValue] = useState<string>("50");
  const [gradingScales, setGradingScales] = useState<GradeRange[]>([]);
  const [remarks, setRemarks] = useState<Remark[]>([]);
  const [opensnack, setOpensnack] = useState(false);
  const [isEditingGradingScale, setIsEditingGradingScale] = useState(false);
  const [editingGradingScales, setEditingGradingScales] = useState<GradeRange[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [editingCell, setEditingCell] = useState<{
    studentId: string;
    subjectId: string;
    assessmentId: string;
  } | null>(null);
  const [editValue, setEditValue] = useState<string>("");
  const [editingRemark, setEditingRemark] = useState<{
    studentId: string;
    subjectId: string;
  } | null>(null);
  const [editRemarkValue, setEditRemarkValue] = useState<string>("");
  const [isAddColumnDialogOpen, setIsAddColumnDialogOpen] = useState(false);
  const [newColumnName, setNewColumnName] = useState("");
  const [newColumnType, setNewColumnType] = useState<AssessmentType>("assignment");

  const [activeSubject, setActiveSubject] = useState<string>("overall");
  const [studentFilter, setStudentFilter] = useState<string>("");
  const [terms, setTerms] = useState<Term[]>(termlist);
  const [activeTerm, setActiveTerm] = useState<string>(props.term);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState<boolean | null>(null);
  const [submitMessage, setSubmitMessage] = useState<string>("");
  const [columnMenuAnchor, setColumnMenuAnchor] = useState<null | HTMLElement>(null);

  // Add new state for persisting data
  const [localStorageKey] = useState(`academic_records_${props.Class_.classname}_${props.term}`);

  // Add new state variables for overall remarks and attendance scores
  const [overallRemarks, setOverallRemarks] = useState<Record<string, string>>({});
  const [attendanceScores, setAttendanceScores] = useState<Record<string, string>>({});
  const [editingOverallRemark, setEditingOverallRemark] = useState<string | null>(null);
  const [editingAttendanceScore, setEditingAttendanceScore] = useState<string | null>(null);
  const [editOverallRemarkValue, setEditOverallRemarkValue] = useState<string>("");
  const [editAttendanceScoreValue, setEditAttendanceScoreValue] = useState<string>("");
  const [overallRemarkSearch, setOverallRemarkSearch] = useState<string>("");
  const [showOverallRemarkSuggestions, setShowOverallRemarkSuggestions] = useState(false);
  const overallRemarkRef = useRef<HTMLDivElement>(null);

  // Add state to track if grading scales have changed
  const [gradingScalesChanged, setGradingScalesChanged] = useState(false);
  const [originalGradingScales, setOriginalGradingScales] = useState<GradeRange[]>([]);

  // Add new state for domain assessment
  const affectiveTraits = [
    'Honesty', 'Neatness', 'Politeness', 'Punctuality/assembly', 'Self-control/calmness', 'Obedience', 'Reliability',
    'Approaches new task with Positive attitude', 'Sense of responsibility', 'Relationship with others',
    'Uses class time appropriately to complete task', 'Follows instructions with minimal supervision',
    'Seeks clarification or assistance when needed', 'Complete and submit task according to agreed-upon timelines',
    'Set individual goals and monitors progress towards achieving them'
  ];
  const psychomotorSkills = [
    'Drawing or Painting', 'Handwriting', 'Public Speaking', 'Speech Fluency', 'Sports and Games'
  ];

  const domainDefault = {
    affective: Object.fromEntries(affectiveTraits.map(trait => [trait, 3])),
    psychomotor: Object.fromEntries(psychomotorSkills.map(skill => [skill, 3]))
  };

  const [domainModal, setDomainModal] = useState<{ open: boolean, studentId: string | null }>({ open: false, studentId: null });
  const [domainRatings, setDomainRatings] = useState<Record<string, { affective: Record<string, number>, psychomotor: Record<string, number> }>>({});

  // Predefined overall remarks suggestions
  const overallRemarkSuggestions = [
    "Excellent academic performance with outstanding behavior",
    "Very good academic performance with commendable behavior",
    "Good academic performance with satisfactory behavior",
    "Satisfactory academic performance with room for improvement",
    "Needs improvement in both academic performance and behavior",
    "Excellent work ethic and positive attitude towards learning",
    "Demonstrates strong leadership qualities and academic excellence",
    "Shows great potential with consistent effort and dedication",
    "Maintains good academic standards with positive classroom behavior",
    "Requires additional support to reach full academic potential",
    "Outstanding achievement in all subject areas",
    "Consistently demonstrates high academic standards",
    "Shows remarkable improvement throughout the term",
    "Displays excellent problem-solving skills and critical thinking",
    "Maintains excellent attendance and punctuality",
    "Demonstrates strong communication skills and teamwork",
    "Shows exceptional creativity and innovation in projects",
    "Maintains high standards of academic integrity",
    "Demonstrates excellent time management and organization skills",
    "Shows great enthusiasm for learning and participation",
    "Requires more focus and dedication to improve performance",
    "Needs to develop better study habits and time management",
    "Shows potential but needs consistent effort",
    "Requires parental support to improve academic performance",
    "Demonstrates good social skills and positive peer relationships",
    "Shows improvement in specific areas but needs continued support",
    "Maintains satisfactory progress with occasional challenges",
    "Requires additional academic support and guidance",
    "Shows good progress in most subject areas",
    "Demonstrates excellent sportsmanship and extracurricular participation",
    "Maintains good classroom behavior and respect for others"
  ];

  // Predefined toddler observational notes organized by categories
  const toddlerObservationalNotes = {
    "Physical Development": [
      "Shows excellent gross motor coordination and balance",
      "Demonstrates strong fine motor skills with precise movements",
      "Exhibits good hand-eye coordination in activities",
      "Shows improvement in physical strength and endurance",
      "Demonstrates age-appropriate physical abilities",
      "Needs encouragement to participate in physical activities",
      "Shows interest in developing new physical skills",
      "Requires support with coordination and balance",
      "Demonstrates good spatial awareness",
      "Shows natural athletic abilities",
      "Needs practice with fine motor precision",
      "Exhibits good posture and body control",
      "Shows enthusiasm for physical play",
      "Requires guidance for safe physical activities",
      "Demonstrates good rhythm and movement"
    ],
    "Language & Communication": [
      "Shows excellent verbal communication skills",
      "Demonstrates rich vocabulary for age level",
      "Expresses thoughts and feelings clearly",
      "Shows good listening and comprehension skills",
      "Engages in meaningful conversations with peers",
      "Demonstrates age-appropriate language development",
      "Shows interest in learning new words",
      "Needs encouragement to speak in group settings",
      "Demonstrates good storytelling abilities",
      "Shows improvement in pronunciation",
      "Engages well in language-based activities",
      "Demonstrates good understanding of instructions",
      "Shows creativity in verbal expression",
      "Needs support with language development",
      "Demonstrates good communication with adults"
    ],
    "Social & Emotional": [
      "Shows excellent social skills and peer interaction",
      "Demonstrates empathy and understanding of others",
      "Exhibits good emotional regulation and self-control",
      "Shows leadership qualities in group activities",
      "Demonstrates positive relationships with classmates",
      "Shows good conflict resolution skills",
      "Exhibits confidence in social situations",
      "Demonstrates good sharing and cooperation",
      "Shows emotional maturity for age level",
      "Engages well in collaborative activities",
      "Demonstrates good manners and respect",
      "Shows interest in making new friends",
      "Exhibits good sportsmanship",
      "Needs support with social interactions",
      "Demonstrates good emotional expression"
    ],
    "Cognitive Development": [
      "Shows excellent problem-solving abilities",
      "Demonstrates strong critical thinking skills",
      "Exhibits good memory and recall abilities",
      "Shows creativity and imagination in activities",
      "Demonstrates good attention span and focus",
      "Shows interest in learning new concepts",
      "Exhibits good logical reasoning skills",
      "Demonstrates age-appropriate cognitive abilities",
      "Shows curiosity and eagerness to learn",
      "Exhibits good pattern recognition skills",
      "Demonstrates good decision-making abilities",
      "Shows improvement in cognitive skills",
      "Exhibits good analytical thinking",
      "Needs encouragement to explore new ideas",
      "Demonstrates good learning strategies"
    ],
    "Behavior & Attitude": [
      "Shows excellent behavior and positive attitude",
      "Demonstrates good self-discipline and focus",
      "Exhibits enthusiasm for learning activities",
      "Shows good classroom behavior and manners",
      "Demonstrates responsibility and reliability",
      "Shows good work ethic and persistence",
      "Exhibits positive attitude toward challenges",
      "Demonstrates good time management skills",
      "Shows improvement in behavior patterns",
      "Exhibits good self-motivation",
      "Demonstrates good organizational skills",
      "Shows respect for rules and routines",
      "Exhibits good impulse control",
      "Needs encouragement to maintain focus",
      "Demonstrates good adaptability to changes"
    ],
    "Learning & Academic": [
      "Shows excellent academic progress and achievement",
      "Demonstrates strong learning abilities",
      "Exhibits good study habits and concentration",
      "Shows enthusiasm for educational activities",
      "Demonstrates good comprehension skills",
      "Shows improvement in academic areas",
      "Exhibits good problem-solving approaches",
      "Demonstrates good memory retention",
      "Shows interest in various subjects",
      "Exhibits good analytical skills",
      "Demonstrates good academic potential",
      "Shows good learning strategies",
      "Exhibits good academic confidence",
      "Needs support with specific learning areas",
      "Demonstrates good academic curiosity"
    ],
    "Creativity & Imagination": [
      "Shows excellent creativity and imagination",
      "Demonstrates strong artistic abilities",
      "Exhibits good creative problem-solving",
      "Shows innovative thinking in activities",
      "Demonstrates good artistic expression",
      "Shows imagination in play and activities",
      "Exhibits good creative confidence",
      "Demonstrates good artistic skills",
      "Shows interest in creative activities",
      "Exhibits good imaginative play",
      "Demonstrates good creative thinking",
      "Shows originality in projects",
      "Exhibits good artistic appreciation",
      "Needs encouragement to express creativity",
      "Demonstrates good creative potential"
    ],
    "Independence & Self-Help": [
      "Shows excellent independence and self-help skills",
      "Demonstrates good self-care abilities",
      "Exhibits good decision-making skills",
      "Shows initiative in daily activities",
      "Demonstrates good organizational skills",
      "Shows responsibility for personal belongings",
      "Exhibits good time management",
      "Demonstrates good problem-solving independence",
      "Shows good self-motivation",
      "Exhibits good self-discipline",
      "Demonstrates good personal responsibility",
      "Shows improvement in independent skills",
      "Exhibits good self-confidence",
      "Needs encouragement to be more independent",
      "Demonstrates good self-reliance"
    ],
    "General Observations": [
      "Shows excellent overall development and progress",
      "Demonstrates good potential in all areas",
      "Exhibits positive attitude toward learning",
      "Shows good adaptation to classroom environment",
      "Demonstrates good overall behavior",
      "Shows improvement across multiple areas",
      "Exhibits good social and academic balance",
      "Demonstrates good classroom participation",
      "Shows enthusiasm for school activities",
      "Exhibits good overall development",
      "Demonstrates good learning readiness",
      "Shows good progress in key areas",
      "Exhibits good classroom engagement",
      "Needs support in multiple areas",
      "Demonstrates good overall potential"
    ]
  };

  // Initialize grading scales from props if available, otherwise use default
  useEffect(() => {
    if (props.Class_.grading && props.Class_.grading.length > 0) {
      // Convert props.Class_.grading to GradeRange format
      const convertedGradingScales = props.Class_.grading.map((item: any) => ({
        remarks: item.remarks || item.grade || "New Grade",
        minScore: item.minScore || 0,
        maxScore: item.maxScore || 0,
        color: item.color || "grey.500",
        gradepoint: item.gradepoint || 0,
        gradeType: item.gradeType || "A"
      }));
      setGradingScales(convertedGradingScales);
      setOriginalGradingScales(convertedGradingScales);
    } else {
      // Use default grading scales with proper grade points (lower is better)
      const defaultGradingScales = [
        { remarks: "Excellent", minScore: 86, maxScore: 100, color: "success.main", gradepoint: 1, gradeType: "A"},
        { remarks: "Very Good", minScore: 71, maxScore: 85, color: "info.main", gradepoint: 2, gradeType: "B" },
        { remarks: "Good", minScore: 61, maxScore: 70, color: "primary.main", gradepoint: 3, gradeType: "C" },
        { remarks: "Credit", minScore: 41, maxScore: 60, color: "warning.main", gradepoint: 4, gradeType: "D" },
        { remarks: "Poor", minScore: 21, maxScore: 40, color: "error.main", gradepoint: 5, gradeType: "E" },
        { remarks: "Fail", minScore: 0, maxScore: 20, color: "error.dark", gradepoint: 6, gradeType: "F" },
      ];
      setGradingScales(defaultGradingScales);
      setOriginalGradingScales(defaultGradingScales);
    }
  }, [props.Class_.grading]);

  // Track changes in grading scales
  useEffect(() => {
    const hasChanged = JSON.stringify(gradingScales) !== JSON.stringify(originalGradingScales);
    setGradingScalesChanged(hasChanged);
  }, [gradingScales, originalGradingScales]);

  // Add useEffect to load persisted data
  useEffect(() => {
    const savedData = localStorage.getItem(localStorageKey);
    if (savedData) {
      const { scores: savedScores, remarks: savedRemarks, specialExamScores: savedSpecialExams } = JSON.parse(savedData);
      setScores(savedScores || []);
      setRemarks(savedRemarks || []);
      setSpecialExamScores(savedSpecialExams || {});
    }
  }, [localStorageKey]);

  // Add useEffect to save data when it changes
  useEffect(() => {
    localStorage.setItem(localStorageKey, JSON.stringify({
      scores,
      remarks,
      specialExamScores
    }));
  }, [scores, remarks, specialExamScores, localStorageKey]);

  // Function to load initial records from props
  const loadInitialRecords = useCallback((termId: string) => {
    const initialScores: ScoreEntry[] = [];
    const initialOverallRemarks: Record<string, string> = {};
    const initialAttendanceScores: Record<string, string> = {};
    const initialDomainRatings: Record<string, { affective: Record<string, number>, psychomotor: Record<string, number> }> = {};
    const initialSpecialExamScores: Record<string, string> = {};
    const assessmentColumnSet = new Set<string>();
    
    // Find academic records for the specified term
    props.students.forEach((student) => {
      const academicRecord = student.academics2?.find(record => record.termId === termId);
      
      if (academicRecord) {
        // Load subject scores and collect assessment columns
        if (academicRecord.subjects) {
          academicRecord.subjects.forEach((subject) => {
            // Check if this is a special exam subject
            const isSpecialExam = isSpecialExamSubject(subject.subjectId);
            
            if (isSpecialExam) {
              // Load special exam score if available
              if (subject.specialExamScore) {
                const key = `${student.ID}-${subject.subjectId}`;
                initialSpecialExamScores[key] = subject.specialExamScore;
              }
            } else {
              // Load regular assessment scores
            if (subject.assessments) {
              subject.assessments.forEach((assessment) => {
                initialScores.push({
                  studentId: student.ID,
                  subjectId: subject.subjectId,
                  assessmentId: assessment.id,
                  score: assessment.score,
                  totalScore: assessment.totalScore,
                  toddlerData: assessment.toddlerData, // Load toddler assessment data
                });
                
                // Track unique assessment columns
                if (!assessmentColumnSet.has(assessment.id)) {
                  assessmentColumnSet.add(assessment.id);
                }
              });
              }
            }
          });
        }
        
        // Load overall remarks
        if (academicRecord.aggregateResults?.overallRemarks) {
          initialOverallRemarks[student.ID] = academicRecord.aggregateResults.overallRemarks;
        }
        
        // Load attendance scores
        if (academicRecord.aggregateResults?.attendanceScore) {
          initialAttendanceScores[student.ID] = academicRecord.aggregateResults.attendanceScore;
        }
        
        // Load domain assessment
        if (academicRecord.domainAssessment) {
          initialDomainRatings[student.ID] = academicRecord.domainAssessment;
        }
      }
    });
    
    // Create assessment columns from existing data if available
    if (assessmentColumnSet.size > 0) {
      const existingColumns: AssessmentColumn[] = [];
      props.students.forEach((student) => {
        const academicRecord = student.academics2?.find(record => record.termId === termId);
        if (academicRecord?.subjects) {
          academicRecord.subjects.forEach((subject) => {
            subject.assessments?.forEach((assessment) => {
              if (!existingColumns.find(col => col.id === assessment.id)) {
                existingColumns.push({
                  id: assessment.id,
                  name: assessment.type === 'exams score' ? 'Exam Score' : 
                        assessment.type === 'assess toddlers' ? 'Assess Toddlers' : assessment.type,
                  type: assessment.type as AssessmentType,
                  visible: true,
                });
              }
            });
          });
        }
      });
      
      if (existingColumns.length > 0) {
        setAssessmentColumns(existingColumns);
      }
    }
    
    setScores(initialScores);
    setOverallRemarks(initialOverallRemarks);
    setAttendanceScores(initialAttendanceScores);
    setDomainRatings(initialDomainRatings);
    setSpecialExamScores(initialSpecialExamScores);
  }, [props.students, isSpecialExamSubject]);

  // Initialize records when component mounts or term changes
  useEffect(() => {
    if (props.term) {
      loadInitialRecords(props.term);
    } else {
      // Reset to default state if no term is provided
      setScores([]);
      setOverallRemarks({});
      setAttendanceScores({});
      setDomainRatings({});
      setSpecialExamScores({});
      setAssessmentColumns(initialAssessmentColumns);
    }
  }, [props.term, loadInitialRecords]);

  // Grade determination - returns the grade type (A, B, C, etc.)
  const determineGrade = useCallback(
    (score: number): string => {
      for (const range of gradingScales) {
        if (score >= range.minScore && score <= range.maxScore) {
          return range.gradeType;
        }
      }
      return "N/A";
    },
    [gradingScales]
  );

  // Determine grade point - returns the grade point value
  const determineGradepoint = useCallback(
    (score: number): number => {
      for (const range of gradingScales) {
        if (score >= range.minScore && score <= range.maxScore) {
          return range.gradepoint;
        }
      }
      return 0;
    },
    [gradingScales]
  );

  // Get remarks from grading scale
  const getGradeRemarks = useCallback(
    (score: number): string => {
      for (const range of gradingScales) {
        if (score >= range.minScore && score <= range.maxScore) {
          return range.remarks;
        }
      }
      return "N/A";
    },
    [gradingScales]
  );

  // Get grade color (modified for MUI palette)
  const getGradeColor = useCallback(
    (grade: string): string => {
      const gradeRange = gradingScales.find((range) => range.gradeType === grade);
      return gradeRange?.color || "grey.500";
    },
    [gradingScales]
  );

  // Handle grading scale editing (unchanged)
  const handleEditGradingScale = useCallback(() => {
    setEditingGradingScales([...gradingScales]);
    setIsEditingGradingScale(true);
  }, [gradingScales]);

  const handleSaveGradingScale = useCallback(() => {
    const sortedScales = [...editingGradingScales].sort((a, b) => b.minScore - a.minScore);
    
    // Validate grading scale ranges
    for (let i = 0; i < sortedScales.length - 1; i++) {
      if (sortedScales[i].minScore <= sortedScales[i + 1].maxScore) {
        setError("Grading scale ranges overlap or have gaps");
        return;
      }
    }
 
    setGradingScales(sortedScales);
    setIsEditingGradingScale(false);
    setError(null);
  }, [editingGradingScales]);

  const updateGradeRange = useCallback(
    (index: number, field: keyof GradeRange, value: string | number) => {
      setEditingGradingScales((prev) => {
        const updatedScales = [...prev];
        if (field === "minScore" || field === "maxScore" || field === "gradepoint") {
          updatedScales[index] = {
            ...updatedScales[index],
            [field]: Number(value),
          };
        } else {
          updatedScales[index] = {
            ...updatedScales[index],
            [field]: value,
          };
        }
        return updatedScales;
      });
    },
    []
  );

  const addGradeRange = useCallback(() => {
    setEditingGradingScales((prev: GradeRange[]) => [
      ...prev,
      {
        remarks: "New Grade",
        minScore: 0,
        maxScore: 0,
        color: "grey.500",
        gradepoint: 0,
        gradeType: "text"
      } as GradeRange,
    ]);
  }, []);

  const removeGradeRange = useCallback((index: number) => {
    setEditingGradingScales((prev) => {
      const updatedScales = [...prev];
      updatedScales.splice(index, 1);
      return updatedScales;
    });
  }, []);

  // Filtered students (unchanged)
  const filteredStudents = useMemo(() => {
    if (!studentFilter) return students;
    return students.filter((student) =>
      student.name.toLowerCase().includes(studentFilter.toLowerCase())
    );
  }, [students, studentFilter]);

  // Visible columns (unchanged)
  const visibleColumns = useMemo(() => {
    return assessmentColumns.filter((col) => col.visible);
  }, [assessmentColumns]);

  // Add column (unchanged)
  const handleAddColumn = useCallback(() => {
    if (!newColumnName.trim()) {
      setError("Column name cannot be empty");
      return;
    }
    const newColumn: AssessmentColumn = {
      id: `col-${Date.now()}`,
      name: newColumnName,
      type: newColumnType,
      visible: true,
    };
    setAssessmentColumns((prev) => [...prev, newColumn]);
    setNewColumnName("");
    setNewColumnType("assignment");
    setIsAddColumnDialogOpen(false);
  }, [newColumnName, newColumnType]);

  // Toggle column visibility (unchanged)
  const toggleColumnVisibility = useCallback((columnId: string) => {
    setAssessmentColumns((prev) =>
      prev.map((col) => (col.id === columnId ? { ...col, visible: !col.visible } : col))
    );
  }, []);

  // Remove column (unchanged)
  const handleRemoveColumn = useCallback((columnId: string) => {
    setAssessmentColumns((prev) => prev.filter((col) => col.id !== columnId));
    setScores((prev) => prev.filter((score) => score.assessmentId !== columnId));
  }, []);

  // Edit cell (unchanged)
  const handleEditCell = useCallback(
    (studentId: string, subjectId: string, assessmentId: string) => {
      const existingScore = scores.find(
        (s) => s.studentId === studentId && s.subjectId === subjectId && s.assessmentId === assessmentId
      );
      if (existingScore) {
        setEditValue(`${existingScore.score}/${existingScore.totalScore}`);
      } else {
        setEditValue("");
      }
      setEditingCell({ studentId, subjectId, assessmentId });
    },
    [scores]
  );

  // Save cell (unchanged)
  const handleSaveCell = useCallback(() => {
    if (!editingCell) return;
    const scorePattern = /^(\d+)\/(\d+)$/;
    if (!editValue.trim()) {
      setScores((prev) =>
        prev.filter(
          (s) =>
            !(
              s.studentId === editingCell.studentId &&
              s.subjectId === editingCell.subjectId &&
              s.assessmentId === editingCell.assessmentId
            )
        )
      );
      setEditingCell(null);
      return;
    }
    if (!scorePattern.test(editValue)) {
      setError('Score must be in format "x/y" (e.g., 25/30)');
      return;
    }
    const [scoreStr, totalScoreStr] = editValue.split("/");
    const score = Number.parseInt(scoreStr);
    const totalScore = Number.parseInt(totalScoreStr);
    if (isNaN(score) || isNaN(totalScore)) {
      setError("Score and total score must be valid numbers");
      return;
    }
    if (score < 0 || totalScore <= 0 || score > totalScore) {
      setError("Invalid score values. Score must be between 0 and total score.");
      return;
    }
    const existingScoreIndex = scores.findIndex(
      (s) =>
        s.studentId === editingCell.studentId &&
        s.subjectId === editingCell.subjectId &&
        s.assessmentId === editingCell.assessmentId
    );
    if (existingScoreIndex >= 0) {
      setScores((prev) => {
        const updatedScores = [...prev];
        updatedScores[existingScoreIndex] = {
          ...updatedScores[existingScoreIndex],
          score,
          totalScore,
        };
        return updatedScores;
      });
    } else {
      setScores((prev) => [
        ...prev,
        {
          studentId: editingCell.studentId,
          subjectId: editingCell.subjectId,
          assessmentId: editingCell.assessmentId,
          score,
          totalScore,
        },
      ]);
    }
    setEditingCell(null);
    setEditValue("");
  }, [editingCell, editValue, scores]);

  // Cancel edit (unchanged)
  const handleCancelEdit = useCallback(() => {
    setEditingCell(null);
    setEditValue("");
  }, []);

  // Handle special exam edit
  const handleEditSpecialExam = useCallback((studentId: string, subjectId: string) => {
    const key = `${studentId}-${subjectId}`;
    const existingScore = specialExamScores[key] || "";
    setEditValue(existingScore);
    setEditingCell({ studentId, subjectId, assessmentId: 'special-exam' });
  }, [specialExamScores]);

  // Handle special exam save
  const handleSaveSpecialExam = useCallback(() => {
    if (!editingCell) return;
    const { studentId, subjectId } = editingCell;
    const key = `${studentId}-${subjectId}`;
    
    if (!editValue.trim()) {
      // Remove special exam score if empty
      setSpecialExamScores((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });
      setEditingCell(null);
      setEditValue("");
      return;
    }
    
    // Validate format: "obtained/total" (e.g., "30/40")
    const scorePattern = /^(\d+)\/(\d+)$/;
    if (!scorePattern.test(editValue)) {
      setError('Special exam score must be in format "obtained/total" (e.g., 30/40)');
      return;
    }
    
    const [obtainedStr, totalStr] = editValue.split("/");
    const obtained = Number.parseInt(obtainedStr);
    const total = Number.parseInt(totalStr);
    
    if (isNaN(obtained) || isNaN(total)) {
      setError("Obtained and total must be valid numbers");
      return;
    }
    
    if (obtained < 0 || total <= 0 || obtained > total) {
      setError("Invalid score values. Obtained must be between 0 and total.");
      return;
    }
    
    // Save special exam score
    setSpecialExamScores((prev) => ({
      ...prev,
      [key]: editValue
    }));
    
    setEditingCell(null);
    setEditValue("");
    setError(null);
  }, [editingCell, editValue]);

  // Get special exam display
  const getSpecialExamDisplay = useCallback((studentId: string, subjectId: string): string => {
    const key = `${studentId}-${subjectId}`;
    return specialExamScores[key] || "-";
  }, [specialExamScores]);

  // Get score display (unchanged)
  const getScoreDisplay = useCallback(
    (studentId: string, subjectId: string, assessmentId: string) => {
      const score = scores.find(
        (s) => s.studentId === studentId && s.subjectId === subjectId && s.assessmentId === assessmentId
      );
      if (!score) return "-";
      return `${score.score}/${score.totalScore}`;
    },
    [scores]
  );

  // Calculate class score (updated to exclude toddler assessments)
  const calculateClassScore = useCallback(
    (studentId: string, subjectId: string) => {
      const classAssessmentIds = assessmentColumns
        .filter((col) => col.type !== "exams score" && col.type !== "assess toddlers" && col.visible)
        .map((col) => col.id);
      const relevantScores = scores.filter(
        (s) => s.studentId === studentId && s.subjectId === subjectId && classAssessmentIds.includes(s.assessmentId)
      );
      if (relevantScores.length === 0) return 0;
      let totalPoints = 0;
      let totalPossiblePoints = 0;
      relevantScores.forEach((score) => {
        // Skip toddler assessments (they use ratings, not numeric scores)
        if (score.score === -1 && score.totalScore === -1) return;
        totalPoints += score.score;
        totalPossiblePoints += score.totalScore;
      });
      if (totalPossiblePoints === 0) return 0;
      const percentage = totalPoints / totalPossiblePoints;
      const scale = Number.parseInt(classScaleValue) || 50;
      return Number((percentage * scale).toFixed(2));
    },
    [assessmentColumns, scores, classScaleValue]
  );

  // Calculate exam score (updated to exclude toddler assessments)
  const calculateExamScore = useCallback(
    (studentId: string, subjectId: string) => {
      const examAssessmentIds = assessmentColumns
        .filter((col) => col.type === "exams score" && col.visible)
        .map((col) => col.id);
      const relevantScores = scores.filter(
        (s) => s.studentId === studentId && s.subjectId === subjectId && examAssessmentIds.includes(s.assessmentId)
      );
      if (relevantScores.length === 0) return 0;
      let totalPoints = 0;
      let totalPossiblePoints = 0;
      relevantScores.forEach((score) => {
        // Skip toddler assessments (they use ratings, not numeric scores)
        if (score.score === -1 && score.totalScore === -1) return;
        totalPoints += score.score;
        totalPossiblePoints += score.totalScore;
      });
      if (totalPossiblePoints === 0) return 0;
      const percentage = totalPoints / totalPossiblePoints;
      const scale = Number.parseInt(examScaleValue) || 50;
      return Number((percentage * scale).toFixed(2));
    },
    [assessmentColumns, scores, examScaleValue]
  );

  // Calculate total score (updated to handle toddler assessments)
  const calculateTotalScore = useCallback(
    (studentId: string, subjectId: string) => {
      const classScore = calculateClassScore(studentId, subjectId);
      const examScore = calculateExamScore(studentId, subjectId);
      return Number((classScore + examScore).toFixed(2));
    },
    [calculateClassScore, calculateExamScore]
  );

  // Get grade (unchanged)
  const getGrade = useCallback(
    (studentId: string, subjectId: string): GradeLevel => {
      const totalScore = calculateTotalScore(studentId, subjectId);
      return determineGrade(totalScore);
    },
    [calculateTotalScore, determineGrade]
  );

  // Calculate position based on totalScore for each subject within the class
  const calculatePosition = useCallback(
    (studentId: string, subjectId: string): string => {
      // Get all students with their total scores for this subject
      // Note: props.students should already be filtered by class
      const studentsWithScores = students
        .map((student) => ({
          id: student.id,
          totalScore: calculateTotalScore(student.id, subjectId),  // Use totalScore, not examScore
        }))
        .filter(student => student.totalScore > 0); // Only include students with scores
      
      if (studentsWithScores.length === 0) return "-";
      
      // Sort by totalScore descending
      const sortedStudents = [...studentsWithScores].sort((a, b) => b.totalScore - a.totalScore);
      
      // Find the student's index
      const studentIndex = sortedStudents.findIndex((student) => student.id === studentId);
      
      if (studentIndex === -1) return "-";
      
      // Handle ties - students with same totalScore get same position
      let position = studentIndex + 1;
      const studentScore = sortedStudents[studentIndex].totalScore;
      
      // Check if there are students with the same score before this student
      // If so, use the position of the first student with that score
      for (let i = studentIndex - 1; i >= 0; i--) {
        if (Math.abs(sortedStudents[i].totalScore - studentScore) < 0.01) { // Handle floating point comparison
          position = i + 1;
        } else {
          break;
        }
      }
      
      return position + getOrdinalSuffix(position);
    },
    [students, calculateTotalScore]  // Depend on calculateTotalScore, not calculateExamScore
  );

  // Student total scores (unchanged)
  const studentTotalScores = useMemo(() => {
    const result: Record<string, number> = {};
    students.forEach((student) => {
      let totalScore = 0;
      let totalSubjectsWithScores = 0;

      subjects.forEach((subject) => {
        const type = subjectTypeMap[subject.id] || '';
        // Skip Special Exams when computing averages for positions
        if (type === 'special exams') return;

        const score = calculateTotalScore(student.id, subject.id);
        if (score > 0) {
          totalScore += score;
          totalSubjectsWithScores++;
        }
      });

      result[student.id] =
        totalSubjectsWithScores === 0
          ? 0
          : Number((totalScore / totalSubjectsWithScores).toFixed(2));
    });
    return result;
  }, [students, subjects, calculateTotalScore, subjectTypeMap]);

  // Calculate all subject total (unchanged)
  const calculateAllSubjectTotal = useCallback(
    (studentId: string): number => {
      const subjectScores = subjects
        .filter((subject) => {
          const type = subjectTypeMap[subject.id] || '';
          return type !== 'special exams';
        })
        .map((subject) => ({
          subjectId: subject.id,
          subjectName: subject.name,
          score: calculateTotalScore(studentId, subject.id),
        }));

      const total = subjectScores.reduce((sum, subject) => sum + subject.score, 0);
      return Number(total.toFixed(2));
    },
    [subjects, calculateTotalScore, subjectTypeMap]
  );

  // Overall positions (unchanged)
  const overallPositions = useMemo(() => {
    const studentsWithScores = students.map((student) => ({
      id: student.id,
      totalScore: studentTotalScores[student.id] || 0,
    }));
    const sortedStudents = [...studentsWithScores].sort((a, b) => b.totalScore - a.totalScore);
    const positions: Record<string, string> = {};
    sortedStudents.forEach((student, index) => {
      const position = index + 1;
      positions[student.id] = position + getOrdinalSuffix(position);
    });
    return positions;
  }, [students, studentTotalScores]);

  // Calculate overall position (unchanged)
  const calculateOverallPosition = useCallback(
    (studentId: string): string => {
      return overallPositions[studentId] || "-";
    },
    [overallPositions]
  );

  // Get remark (unchanged)
  const getRemark = useCallback(
    (studentId: string, subjectId: string): string => {
      const remark = remarks.find((r) => r.studentId === studentId && r.subjectId === subjectId);
      return remark ? remark.text : "";
    },
    [remarks]
  );

  // Edit remark (unchanged)
  const handleEditRemark = useCallback(
    (studentId: string, subjectId: string) => {
      const existingRemark = remarks.find((r) => r.studentId === studentId && r.subjectId === subjectId);
      if (existingRemark) {
        setEditRemarkValue(existingRemark.text);
      } else {
        setEditRemarkValue("");
      }
      setEditingRemark({ studentId, subjectId });
    },
    [remarks]
  );

  // Save remark (unchanged)
  const handleSaveRemark = useCallback(() => {
    if (!editingRemark) return;
    if (!editRemarkValue.trim()) {
      setRemarks((prev) =>
        prev.filter(
          (r) => !(r.studentId === editingRemark.studentId && r.subjectId === editingRemark.subjectId)
        )
      );
    } else {
      const existingRemarkIndex = remarks.findIndex(
        (r) => r.studentId === editingRemark.studentId && r.subjectId === editingRemark.subjectId
      );
      if (existingRemarkIndex >= 0) {
        setRemarks((prev) => {
          const updatedRemarks = [...prev];
          updatedRemarks[existingRemarkIndex] = {
            ...updatedRemarks[existingRemarkIndex],
            text: editRemarkValue,
          };
          return updatedRemarks;
        });
      } else {
        setRemarks((prev) => [
          ...prev,
          {
            studentId: editingRemark.studentId,
            subjectId: editingRemark.subjectId,
            text: editRemarkValue,
          },
        ]);
      }
    }
    setEditingRemark(null);
    setEditRemarkValue("");
  }, [editingRemark, editRemarkValue, remarks]);

  // Cancel remark edit (unchanged)
  const handleCancelRemarkEdit = useCallback(() => {
    setEditingRemark(null);
    setEditRemarkValue("");
  }, []);

  // Add student (unchanged)
  const handleAddStudent = useCallback(() => {
    const newId = `s${students.length + 1}`;
    const newStudent = { id: newId, name: `Student ${students.length + 1}` };
    setStudents((prev) => [...prev, newStudent]);
  }, [students]);

  // Add subject (unchanged)
  const handleAddSubject = useCallback(() => {
    const newId = `sub${subjects.length + 1}`;
    const newSubject = { id: newId, name: `Subject ${subjects.length + 1}` };
    setSubjects((prev) => [...prev, newSubject]);
  }, [subjects]);

  // Color options (modified for MUI)
  const colorOptions = useMemo(
    () => [
      { label: "Green", value: "success.main" },
      { label: "Blue", value: "primary.main" },
      { label: "Yellow", value: "warning.main" },
      { label: "Red", value: "error.main" },
      { label: "Gray", value: "grey.500" },
    ],
    []
  );

  // Fix calculateBestSixSubjects to use grade points properly
  const calculateBestSixSubjects = useCallback(
    (studentId: string): number => {
      // Exclude subjects whose class type is "special exams"
      const subjectScores = subjects
        .filter((subject) => {
          const type = subjectTypeMap[subject.id] || '';
          return type !== 'special exams';
        })
        .map((subject) => ({
          subjectId: subject.id,
          subjectName: subject.name,
          score: calculateTotalScore(studentId, subject.id),
        }));

      const sortedScores = [...subjectScores].sort((a, b) => b.score - a.score);
      const bestSix = sortedScores.slice(0, Math.min(6, sortedScores.length));
      
      return bestSix.reduce((sum: number, subject) => {
        const gradepoint = determineGradepoint(subject.score);
        return sum + (typeof gradepoint === 'number' ? gradepoint : 0);
      }, 0);
    },
    [subjects, calculateTotalScore, determineGradepoint, subjectTypeMap]
  );

  // Add new handlers for overall remarks and attendance scores
  const handleEditOverallRemark = useCallback((studentId: string) => {
    setEditOverallRemarkValue(overallRemarks[studentId] || "");
    setEditingOverallRemark(studentId);
    setShowOverallRemarkSuggestions(false);
  }, [overallRemarks]);

  // Filter overall remark suggestions based on search
  const filteredOverallRemarkSuggestions = useMemo(() => {
    if (!overallRemarkSearch.trim()) return overallRemarkSuggestions;
    return overallRemarkSuggestions.filter(remark =>
      remark.toLowerCase().includes(overallRemarkSearch.toLowerCase())
    );
  }, [overallRemarkSearch]);

  const handleOverallRemarkSuggestionClick = useCallback((suggestion: string) => {
    setEditOverallRemarkValue(suggestion);
    setShowOverallRemarkSuggestions(false);
    setOverallRemarkSearch("");
  }, []);

  const handleSaveOverallRemark = useCallback(() => {
    if (!editingOverallRemark) return;
    setOverallRemarks(prev => ({
      ...prev,
      [editingOverallRemark]: editOverallRemarkValue
    }));
    setEditingOverallRemark(null);
    setEditOverallRemarkValue("");
    setShowOverallRemarkSuggestions(false);
    setOverallRemarkSearch("");
  }, [editingOverallRemark, editOverallRemarkValue]);

  const handleEditAttendanceScore = useCallback((studentId: string) => {
    setEditAttendanceScoreValue(attendanceScores[studentId] || "");
    setEditingAttendanceScore(studentId);
  }, [attendanceScores]);

  const handleSaveAttendanceScore = useCallback(() => {
    if (!editingAttendanceScore) return;
    const scorePattern = /^\d+\/\d+$/;
    if (!scorePattern.test(editAttendanceScoreValue)) {
      setError('Attendance score must be in format "x/y" (e.g., 20/25)');
      return;
    }
    setAttendanceScores(prev => ({
      ...prev,
      [editingAttendanceScore]: editAttendanceScoreValue
    }));
    setEditingAttendanceScore(null);
    setEditAttendanceScoreValue("");
  }, [editingAttendanceScore, editAttendanceScoreValue]);

  // Update prepareDataForSubmission to include grade type and grade point
  const prepareDataForSubmission = useCallback((): StudentRecord[] => {
    return students.map((student) => {
      const subjectRecords: SubjectRecord[] = subjects.map((subject) => {
        // Check if this is a special exam subject
        const isSpecialExam = isSpecialExamSubject(subject.id);
        
        if (isSpecialExam) {
          // For special exams, only include the special exam score
          const key = `${student.id}-${subject.id}`;
          const specialExamScore = specialExamScores[key] || "";
          
          return {
            subjectId: subject.id,
            subjectName: subject.name,
            assessments: [], // No assessments for special exams
            classScore: 0,
            examScore: 0,
            totalScore: 0, // No total score calculation for special exams
            grade: "",
            position: "",
            remarks: "",
            gradeType: "",
            gradePoint: 0,
            specialExamScore: specialExamScore, // Include special exam score in "obtained/total" format
          };
        } else {
          // Regular subject: include assessments and calculated scores
        const subjectAssessments = scores
          .filter((s) => s.studentId === student.id && s.subjectId === subject.id)
          .map((s) => {
            const column = assessmentColumns.find((col) => col.id === s.assessmentId);
            return {
              id: s.assessmentId,
              type: column?.type || "assignment",
              score: s.score,
              totalScore: s.totalScore,
              toddlerData: s.toddlerData, // Include toddler assessment data
            };
          });
        
        const totalScore = calculateTotalScore(student.id, subject.id);
        const gradeType = determineGrade(totalScore);
        const gradePoint = determineGradepoint(totalScore);
        const gradeRemarks = getGradeRemarks(totalScore);
        
        return {
          subjectId: subject.id,
          subjectName: subject.name,
          assessments: subjectAssessments,
          classScore: calculateClassScore(student.id, subject.id),
          examScore: calculateExamScore(student.id, subject.id),
          totalScore: totalScore,
          grade: gradeType,
          position: calculatePosition(student.id, subject.id),
          remarks: gradeRemarks,
          gradeType: gradeType,
          gradePoint: gradePoint,
        };
        }
      });
      return {
        studentId: student.id,
        studentName: student.name,
        termId: activeTerm,
        subjects: subjectRecords,
        aggregateResults: {
          bestSixTotal: calculateBestSixSubjects(student.id),
          overallPosition: calculateOverallPosition(student.id),
          overallRemarks: overallRemarks[student.id] || "",
          attendanceScore: attendanceScores[student.id] || "",
        },
        domainAssessment: domainRatings[student.id] || domainDefault,
        classScale: parseInt(classScaleValue) || 50,
        examScale: parseInt(examScaleValue) || 50
      };
    });
  }, [
    students,
    subjects,
    scores,
    assessmentColumns,
    activeTerm,
    calculateClassScore,
    calculateExamScore,
    calculateTotalScore,
    determineGrade,
    determineGradepoint,
    getGradeRemarks,
    calculatePosition,
    calculateBestSixSubjects,
    calculateOverallPosition,
    overallRemarks,
    attendanceScores,
    domainRatings,
    classScaleValue,
    examScaleValue,
    isSpecialExamSubject,
    specialExamScores
  ]);

  // Submit data (unchanged)
  const handleSubmitData = async () => {
    setIsSubmitting(true);
    setSubmitSuccess(null);
    setSubmitMessage("");

    try {
        const data = prepareDataForSubmission();
        console.log(data)
        
        // Make API call to update records
        const response = await axios.post('https://servermain.sisrevolution.com/api/students/addresults2',
            {
                termId: activeTerm,
                termName: terms.find((t) => t.id === activeTerm)?.name,
                students: data,
            }
        );

        if (response.status===200) {
            // Update local academics2 data
            const updatedStudents = stud.map(student => {
                const studentData = data.find(d => d.studentId === student.ID);
                if (studentData) {
                    // Check if term exists in academics2
                    const existingTermIndex = student.academics2?.findIndex(
                        record => record.termId === activeTerm
                    );
                    
                    if (existingTermIndex !== undefined && existingTermIndex !== -1) {
                        // Update existing term data
                        const updatedAcademics2 = [...(student.academics2 || [])];
                        updatedAcademics2[existingTermIndex] = {
                            ...studentData,
                            termId: activeTerm,
                            termName: terms.find((t) => t.id === activeTerm)?.name
                        };
                        return {
                            ...student,
                            academics2: updatedAcademics2
                        };
                    } else {
                        // Add new term data
                        return {
                            ...student,
                            academics2: [
                                ...(student.academics2 || []),
                                {
                                    ...studentData,
                                    termId: activeTerm,
                                    termName: terms.find((t) => t.id === activeTerm)?.name
                                }
                            ]
                        };
                    }
                }
                return student;
            });
            console.log("updatedStudents")
            console.log(updatedStudents)
            // Ensure we have valid data before dispatching
            if (updatedStudents && updatedStudents.length > 0) {
                // Update Redux store with new data
                dispatch(getdata({
                  data: updatedStudents
              }))
                
                // Submit grading scales if they have changed
                if (gradingScalesChanged) {
                    try {
                        const gradingResponse = await axios.post('https://servermain.sisrevolution.com/api/class/updategrading',
                            {
                                schoolID: props.Class_.schoolID,
                                classId: props.Class_._id,
                                grading: gradingScales,
                                classScale: parseInt(classScaleValue) || 50,
                                examScale: parseInt(examScaleValue) || 50
                            }
                        );
                        
                        if (gradingResponse.status === 200) {
                            console.log('Grading scales updated successfully');
                            setGradingScalesChanged(false);
                            setOriginalGradingScales([...gradingScales]);
                            
                            // Update Class_ data in Redux
                            const updatedClassData = {
                                ...props.Class_,
                                grading: gradingScales,
                                classscale: parseInt(classScaleValue) || 50,
                                examscale: parseInt(examScaleValue) || 50
                            };
                            
                            // Find and update the specific class in the array
                            const updatedClassArray = currentClassData.map((classItem: any) => {
                                if (classItem._id === props.Class_._id) {
                                    return updatedClassData;
                                }
                                return classItem;
                            });
                            
                            dispatch(getdata_({
                                data: updatedClassArray
                            }));
                        } else {
                            console.log('Failed to update grading scales');
                        }
                    } catch (gradingError) {
                        console.log('Error updating grading scales:', gradingError);
                    }
                }
                
                // Show success notification
                setOpensnack(true);
                setSubmitSuccess(true);
                setSubmitMessage("Academic records updated successfully!");
            } else {
                throw new Error('Failed to update student records');
            }
        } else {
            throw new Error((response.data as any)?.message || 'Failed to update records');
        }
    } catch (error: any) {
        console.log('Error updating academic records:', error);
        setOpensnack(true);
        setSubmitSuccess(false);
        setSubmitMessage(error.response?.data?.message || "Failed to update academic records. Please try again.");
    } finally {
        setIsSubmitting(false);
    }
  };

  // Add new function to handle term changes
  const handleTermChange = (termId: string) => {
    setActiveTerm(termId);
    loadInitialRecords(termId);
  };

  // Initialize scale values from props if available
  useEffect(() => {
    if (props.Class_.classscale) {
      setClassScaleValue(props.Class_.classscale.toString());
    }
    if (props.Class_.examscale) {
      setExamScaleValue(props.Class_.examscale.toString());
    }
  }, [props.Class_.classscale, props.Class_.examscale]);

  // Handle click outside to close suggestions
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (overallRemarkRef.current && !overallRemarkRef.current.contains(event.target as Node)) {
        setShowOverallRemarkSuggestions(false);
      }
      if (observationalNotesRef.current && !observationalNotesRef.current.contains(event.target as Node)) {
        setShowObservationalNotesSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Add new handler for domain assessment
  const handleOpenDomainModal = (studentId: string) => {
    setDomainModal({ open: true, studentId });
  };
  const handleCloseDomainModal = () => {
    setDomainModal({ open: false, studentId: null });
  };
  const handleDomainRatingChange = (type: 'affective' | 'psychomotor', trait: string, value: number) => {
    if (!domainModal.studentId) return;
    setDomainRatings(prev => ({
      ...prev,
      [domainModal.studentId!]: {
        ...((prev[domainModal.studentId!] || domainDefault)),
        [type]: {
          ...((prev[domainModal.studentId!] || domainDefault)[type]),
          [trait]: value
        }
      }
    }));
  };
  const handleSaveDomainModal = () => {
    // Optionally: persist to backend or include in submission
    handleCloseDomainModal();
  };

  // Enhanced toddler rating options with more granular levels
  const toddlerRatingOptions = [
    { value: "Outstanding", label: "Outstanding", color: "success.dark", description: "Exceptional performance beyond age expectations" },
    { value: "Excellent", label: "Excellent", color: "success.main", description: "Consistently meets and exceeds age expectations" },
    { value: "Very Good", label: "Very Good", color: "info.main", description: "Frequently meets age expectations with some excellence" },
    { value: "Good", label: "Good", color: "primary.main", description: "Generally meets age expectations" },
    { value: "Satisfactory", label: "Satisfactory", color: "primary.light", description: "Meets basic age expectations" },
    { value: "Emerging", label: "Emerging", color: "warning.light", description: "Beginning to show skills, needs encouragement" },
    { value: "Developing", label: "Developing", color: "warning.main", description: "Skills are developing with support" },
    { value: "Needs Improvement", label: "Needs Improvement", color: "error.light", description: "Requires additional support and practice" },
    { value: "Requires Support", label: "Requires Support", color: "error.main", description: "Needs significant support and intervention" },
    { value: "Not Observed", label: "Not Observed", color: "grey.500", description: "Skill not observed during assessment period" }
  ];

  // Comprehensive toddler milestones organized by developmental domains
  const toddlerMilestones = {
    "Physical Development": [
      "Walks independently", "Runs with coordination", "Climbs stairs with assistance", "Jumps with both feet",
      "Throws and catches ball", "Balances on one foot briefly", "Pedals tricycle", "Uses scissors with supervision",
      "Builds tower of 6+ blocks", "Draws simple shapes", "Strings large beads", "Pours liquid without spilling",
      "Uses spoon and fork effectively", "Dresses with minimal assistance", "Uses toilet independently",
      "Washes hands properly", "Brushes teeth with help", "Climbs playground equipment", "Kicks ball forward", "Walks on tiptoes"
    ],
    "Language & Communication": [
      "Says first words", "Uses 2-word phrases", "Follows simple instructions", "Names familiar objects",
      "Asks simple questions", "Uses pronouns (I, you, me)", "Sings simple songs", "Recites nursery rhymes",
      "Tells simple stories", "Uses past tense correctly", "Speaks clearly enough for strangers to understand",
      "Uses 3-4 word sentences", "Understands basic concepts (big/small, up/down)", "Responds to name",
      "Makes eye contact during conversation", "Uses gestures to communicate", "Imitates sounds and words",
      "Shows interest in books", "Points to pictures when named", "Engages in pretend play with language"
    ],
    "Cognitive Development": [
      "Recognizes colors", "Counts to 5", "Sorts objects by color/shape", "Completes simple puzzles",
      "Understands cause and effect", "Shows curiosity about environment", "Remembers simple routines",
      "Matches similar objects", "Identifies body parts", "Understands basic time concepts",
      "Shows problem-solving skills", "Engages in pretend play", "Follows 2-step directions",
      "Recognizes familiar logos/signs", "Shows interest in numbers", "Understands spatial concepts",
      "Remembers events from yesterday", "Shows creativity in play", "Demonstrates logical thinking",
      "Shows attention span of 5+ minutes"
    ],
    "Social & Emotional": [
      "Plays with other children", "Shares toys with prompting", "Shows empathy for others",
      "Expresses emotions appropriately", "Separates from parents easily", "Follows classroom rules",
      "Takes turns in games", "Shows independence", "Comforts others when upset", "Shows pride in accomplishments",
      "Cooperates with adults", "Shows interest in making friends", "Handles frustration appropriately",
      "Shows confidence in new situations", "Demonstrates self-control", "Shows respect for others",
      "Participates in group activities", "Shows leadership qualities", "Demonstrates good manners",
      "Shows resilience when facing challenges"
    ],
    "Self-Help Skills": [
      "Feeds self with utensils", "Drinks from cup without spilling", "Washes hands independently",
      "Uses toilet with assistance", "Dresses with help", "Puts on shoes (with assistance)",
      "Cleans up toys", "Brushes teeth with supervision", "Wipes nose when reminded", "Opens containers independently",
      "Carries own belongings", "Follows safety rules", "Uses tissues properly", "Puts away personal items",
      "Shows awareness of personal space", "Demonstrates good hygiene habits", "Manages simple tasks independently",
      "Shows responsibility for belongings", "Follows daily routines", "Demonstrates self-care awareness"
    ],
    "Creative & Artistic": [
      "Enjoys drawing and coloring", "Creates simple artwork", "Sings songs and rhymes", "Dances to music",
      "Engages in dramatic play", "Uses imagination in play", "Explores different art materials",
      "Creates patterns with objects", "Responds to music and rhythm", "Shows creativity in problem-solving",
      "Enjoys storytelling", "Participates in creative activities", "Shows appreciation for art",
      "Expresses ideas through art", "Engages in role-playing", "Creates simple structures",
      "Shows interest in different textures", "Demonstrates artistic expression", "Enjoys creative movement",
      "Shows originality in play"
    ],
    "Motor Skills": [
      "Fine motor precision", "Hand-eye coordination", "Gross motor coordination", "Balance and stability",
      "Manual dexterity", "Spatial awareness", "Bilateral coordination", "Visual tracking", "Motor planning",
      "Strength and endurance", "Agility and speed", "Postural control", "Crossing midline",
      "Sequential movements", "Rhythmic movements", "Precision grip", "Whole body coordination",
      "Visual-motor integration", "Motor memory", "Adaptive motor skills"
    ]
  };

  // Add new state for toddler assessment modal
  const [toddlerAssessmentModal, setToddlerAssessmentModal] = useState<{
    open: boolean;
    studentId: string | null;
    subjectId: string | null;
    assessmentId: string | null;
  }>({ open: false, studentId: null, subjectId: null, assessmentId: null });

  const [toddlerAssessmentData, setToddlerAssessmentData] = useState<ToddlerAssessmentData>({
    rating: "Not Observed",
    notes: "",
    milestone: "",
    category: ""
  });

  // Add state for observational notes search
  const [observationalNotesSearch, setObservationalNotesSearch] = useState<string>("");
  const [showObservationalNotesSuggestions, setShowObservationalNotesSuggestions] = useState(false);
  const observationalNotesRef = useRef<HTMLDivElement>(null);

  // Add toddler assessment functions
  const handleToddlerAssessment = useCallback((
    studentId: string, 
    subjectId: string, 
    assessmentId: string
  ) => {
    const existingScore = scores.find(
      (s) => s.studentId === studentId && s.subjectId === subjectId && s.assessmentId === assessmentId
    );
    
    // Check if this is a toddler assessment (score === -1 indicates toddler assessment)
    if (existingScore?.score === -1 && existingScore?.totalScore === -1 && existingScore?.toddlerData) {
      setToddlerAssessmentData(existingScore.toddlerData);
    } else {
      setToddlerAssessmentData({
        rating: "Not Observed",
        notes: "",
        milestone: "",
        category: ""
      });
    }
    
    setToddlerAssessmentModal({
      open: true,
      studentId,
      subjectId,
      assessmentId
    });
  }, [scores]);

  // Save toddler assessment
  const handleSaveToddlerAssessment = useCallback(() => {
    if (!toddlerAssessmentModal.studentId || !toddlerAssessmentModal.subjectId || !toddlerAssessmentModal.assessmentId) {
      return;
    }

    const { studentId, subjectId, assessmentId } = toddlerAssessmentModal;
    
    // For toddler assessments, store the actual rating text instead of numeric points
    // Use a special score value to indicate this is a toddler assessment
    const score = -1; // Special indicator for toddler assessment
    const totalScore = -1; // Special indicator for toddler assessment

    const existingScoreIndex = scores.findIndex(
      (s) => s.studentId === studentId && s.subjectId === subjectId && s.assessmentId === assessmentId
    );

    if (existingScoreIndex >= 0) {
      setScores((prev) => {
        const updatedScores = [...prev];
        updatedScores[existingScoreIndex] = {
          ...updatedScores[existingScoreIndex],
          score,
          totalScore,
          toddlerData: toddlerAssessmentData
        };
        return updatedScores;
      });
    } else {
      setScores((prev) => [
        ...prev,
        {
          studentId,
          subjectId,
          assessmentId,
          score,
          totalScore,
          toddlerData: toddlerAssessmentData
        },
      ]);
    }

    setToddlerAssessmentModal({ open: false, studentId: null, subjectId: null, assessmentId: null });
  }, [toddlerAssessmentModal, toddlerAssessmentData, scores]);

  // Get toddler assessment display
  const getToddlerAssessmentDisplay = useCallback((
    studentId: string, 
    subjectId: string, 
    assessmentId: string
  ) => {
    const score = scores.find(
      (s) => s.studentId === studentId && s.subjectId === subjectId && s.assessmentId === assessmentId
    );
    
    // Check if this is a toddler assessment (score === -1 indicates toddler assessment)
    if (score?.score === -1 && score?.totalScore === -1) {
      if (!score?.toddlerData) return "Not Assessed";
      
      const rating = score.toddlerData.rating;
      const hasNotes = score.toddlerData.notes?.trim();
      const hasMilestone = score.toddlerData.milestone?.trim();
      
      let display = rating;
      if (hasNotes || hasMilestone) {
        display += " *";
      }
      
      return display;
    }
    
    return "Not Assessed";
  }, [scores]);

  // Filter observational notes based on search
  const filteredObservationalNotes = useMemo(() => {
    const allNotes: string[] = [];
    Object.values(toddlerObservationalNotes).forEach(categoryNotes => {
      allNotes.push(...categoryNotes);
    });
    
    if (!observationalNotesSearch.trim()) {
      // Show all notes when no search term (when field is focused)
      return allNotes;
    }
    
    // Filter notes based on search term
    return allNotes.filter(note =>
      note.toLowerCase().includes(observationalNotesSearch.toLowerCase())
    );
  }, [observationalNotesSearch]);

  const handleObservationalNoteSuggestionClick = useCallback((suggestion: string) => {
    setToddlerAssessmentData(prev => ({
      ...prev,
      notes: suggestion
    }));
    setShowObservationalNotesSuggestions(false);
    setObservationalNotesSearch("");
  }, []);

  // Render UI
  return (
    <Box sx={{ 
      // width: '100vw',
      // height: '100vh',
      // position: 'fixed',
      // top: 0,
      // left: 0,
      bgcolor: 'background.paper',
      // zIndex: 1300,
      // overflow: 'auto'
    }}>
      <Box sx={{ maxWidth: 1200, mx: "auto", py: 4, px: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="h4">
            Student Score Calculator
          </Typography>
          
          {/* <Button 
            variant="contained" 
            color="primary"
            onClick={() => {
              // Clear persisted data when closing
              localStorage.removeItem(localStorageKey);
              props.onClose?.();
            }}
          >
            Close
          </Button> */}

        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "stretch", sm: "center" }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setIsAddColumnDialogOpen(true)}
            >
              Add Assessment Column
            </Button>
            {/* <Button variant="outlined" onClick={handleAddStudent}>
              Add Student
            </Button> */}
            {/* <Button variant="outlined" onClick={handleAddSubject}>
              Add Subject
            </Button> */}
            <Button
              variant="outlined"
              startIcon={<Settings />}
              onClick={(e) => setColumnMenuAnchor(e.currentTarget)}
            >
              Column Visibility
            </Button>
            <Menu
              anchorEl={columnMenuAnchor}
              open={Boolean(columnMenuAnchor)}
              onClose={() => setColumnMenuAnchor(null)}
            >
              <MenuItem disabled>
                <Typography variant="subtitle2">Toggle Columns</Typography>
              </MenuItem>
              {assessmentColumns.map((column) => (
                <MenuItem
                  key={column.id}
                  onClick={() => toggleColumnVisibility(column.id)}
                >
                  <Checkbox checked={column.visible} />
                  <Typography>{column.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Stack>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            alignItems="center"
          >
            <Box>
              <FormLabel htmlFor="class-scale-value">Class Scale:</FormLabel>
              <TextField
                id="class-scale-value"
                type="number"
                value={classScaleValue}
                onChange={(e) => setClassScaleValue(e.target.value)}
                size="small"
                sx={{ width: 80, ml: 1 }}
              />
            </Box>
            <Box>
              <FormLabel htmlFor="exam-scale-value">Exam Scale:</FormLabel>
              <TextField
                id="exam-scale-value"
                type="number"
                value={examScaleValue}
                onChange={(e) => setExamScaleValue(e.target.value)}
                size="small"
                sx={{ width: 80, ml: 1 }}
              />
            </Box>
            <Box>
              <FormLabel htmlFor="overall-scale-value">Overall Scale:</FormLabel>
              <TextField
                id="overall-scale-value"
                type="number"
                value={overallScaleValue}
                onChange={(e) => setOverallScaleValue(e.target.value)}
                size="small"
                sx={{ width: 80, ml: 1 }}
              />
            </Box>
          </Stack>
        </Stack>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Paper sx={{ p: 2, mb: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                Grading Scale:
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {gradingScales.map((scale) => (
                  <Chip
                    key={scale.remarks}
                    label={`${scale.minScore}-${scale.maxScore}: ${scale.remarks}`}
                    color={
                      scale.color.includes("success")
                        ? "success"
                        : scale.color.includes("info")
                        ? "info"
                        : scale.color.includes("primary")
                        ? "primary"
                        : scale.color.includes("warning")
                        ? "warning"
                        : "error"
                    }
                    variant="outlined"
                  />
                ))}
              </Stack>
            </Box>
            <Button
              variant="outlined"
              startIcon={<Tune />}
              onClick={handleEditGradingScale}
            >
              Customize Grading Scale
            </Button>
          </Stack>
        </Paper>

        <Dialog
          open={isAddColumnDialogOpen}
          onClose={() => setIsAddColumnDialogOpen(false)}
        >
          <DialogTitle>Add New Assessment Column</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Create a new column for tracking student assessments.
            </DialogContentText>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Name"
                  value={newColumnName}
                  onChange={(e) => setNewColumnName(e.target.value)}
                  placeholder="e.g., Midterm Exam"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Type</InputLabel>
                  <Select
                    value={newColumnType}
                    onChange={(e) => setNewColumnType(e.target.value as AssessmentType)}
                    label="Type"
                  >
                    <MenuItem value="assignment">Assignment</MenuItem>
                    <MenuItem value="exercise">Exercise</MenuItem>
                    <MenuItem value="test">Test</MenuItem>
                    <MenuItem value="exams score">Exams Score</MenuItem>
                    <MenuItem value="assess toddlers">Assess toddlers (for improvement)</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsAddColumnDialogOpen(false)}>Cancel</Button>
            <Button onClick={handleAddColumn} variant="contained">
              Add Column
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isEditingGradingScale}
          onClose={() => setIsEditingGradingScale(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Customize Grading Scale</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Define your own grading scale ranges and labels. You can use text grades (e.g., "Excellent") or alphabet grades (e.g., "A", "B", "C").
            </DialogContentText>
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2} sx={{ mb: 2, fontWeight: "medium" }}>
                <Grid item xs={2}>
                  Grade Name
                </Grid>
                <Grid item xs={2}>
                  Min Score
                </Grid>
                <Grid item xs={2}>
                  Max Score
                </Grid>
                <Grid item xs={2}>
                  Grade Type
                </Grid>
                <Grid item xs={2}>
                  Grade Point
                </Grid>
                <Grid item xs={1}>
                  Color
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              {editingGradingScales.map((scale, index) => (
                <Grid container spacing={2} alignItems="center" key={index} sx={{ mb: 1 }}>
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      value={scale.remarks}
                      onChange={(e) => updateGradeRange(index, "remarks", e.target.value)}
                      placeholder="e.g., A or Excellent"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      type="number"
                      value={scale.minScore}
                      onChange={(e) => updateGradeRange(index, "minScore", e.target.value)}
                      placeholder="Min score"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      type="number"
                      value={scale.maxScore}
                      onChange={(e) => updateGradeRange(index, "maxScore", e.target.value)}
                      placeholder="Max score"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      value={scale.gradeType}
                      onChange={(e) => updateGradeRange(index, "gradeType", e.target.value)}
                      placeholder="text or alphabet"
                      size="small"
                    />
                  </Grid> 
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      type="number"
                      value={scale.gradepoint}
                      onChange={(e) => updateGradeRange(index, "gradepoint", e.target.value)}
                      placeholder="GradePoint"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Color</InputLabel>
                      <Select
                        value={scale.color}
                        onChange={(e) => updateGradeRange(index, "color", e.target.value)}
                        label="Color"
                      >
                        {colorOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Box
                                sx={{
                                  width: 16,
                                  height: 16,
                                  borderRadius: 1,
                                  bgcolor: option.value,
                                  mr: 1,
                                }}
                              />
                              {option.label}
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}>
                    <IconButton onClick={() => removeGradeRange(index)}>
                      <Close />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
              <Button
                variant="outlined"
                startIcon={<Add />}
                onClick={addGradeRange}
                sx={{ mt: 2 }}
              >
                Add Grade Level
              </Button>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsEditingGradingScale(false)}>Cancel</Button>
            <Button onClick={handleSaveGradingScale} variant="contained">
              Save Grading Scale
            </Button>
          </DialogActions>
        </Dialog>

        <Tabs
          value={activeSubject}
          onChange={(e, newValue) => setActiveSubject(newValue)}
          sx={{ mb: 2 }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Overall" value="overall" />
          {subjects.map((subject) => (
            <Tab key={subject.id} label={subject.name} value={subject.id} />
          ))}
        </Tabs>

        {activeSubject === "overall" && (
          <Box>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
              <Search fontSize="small" color="action" />
              <TextField
                placeholder="Search students..."
                value={studentFilter}
                onChange={(e) => setStudentFilter(e.target.value)}
                size="small"
                sx={{ maxWidth: 300 }}
              />
            </Stack>
            <TableContainer component={Paper}>
              <Table sx={{ border: 1, borderColor: "grey.300" }}>
                <TableHead sx={{ position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 10 }}>
                  <TableRow>
                    <TableCell sx={{ bgcolor: "grey.200", position: "sticky", left: 0, zIndex: 20 }}>
                      Student
                    </TableCell>
                    {subjects.map((subject) => (
                      <TableCell key={subject.id} align="right">
                        {subject.name}
                      </TableCell>
                    ))}
                    <TableCell sx={{ bgcolor: "grey.200" }} align="right">
                      All Subject Total
                    </TableCell>
                    <TableCell sx={{ bgcolor: "grey.200" }} align="right">
                      Aggregate
                    </TableCell>
                    <TableCell sx={{ bgcolor: "grey.200" }}>Overall Position</TableCell>
                    <TableCell sx={{ bgcolor: "grey.200" }}>Attendance Score</TableCell>
                    <TableCell sx={{ bgcolor: "grey.200" }}>Overall Remarks</TableCell>
                    <TableCell sx={{ bgcolor: "grey.200" }}>Domain</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredStudents.map((student) => (
                    <TableRow key={student.id}>
                      <TableCell sx={{ fontWeight: "medium", position: "sticky", left: 0, bgcolor: "background.paper" }}>
                        {student.name}
                      </TableCell>
                      {subjects.map((subject) => (
                        <TableCell key={`${student.id}-${subject.id}`} align="right">
                          {calculateTotalScore(student.id, subject.id).toFixed(2)}
                        </TableCell>
                      ))}
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        {calculateAllSubjectTotal(student.id).toFixed(2)}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", bgcolor: "grey.100" }} align="right">
                        {calculateBestSixSubjects(student.id)}
                      </TableCell>
                      <TableCell>
                        {calculateAllSubjectTotal(student.id) > 0 ? calculateOverallPosition(student.id) : "-"}
                      </TableCell>
                      <TableCell sx={{ p: 0 }}>
                        {editingAttendanceScore === student.id ? (
                          <Stack direction="row" alignItems="center" sx={{ p: 1 }}>
                            <TextField
                              value={editAttendanceScoreValue}
                              onChange={(e) => setEditAttendanceScoreValue(e.target.value)}
                              placeholder="e.g., 20/25"
                              fullWidth
                              variant="outlined"
                              InputProps={{
                                style: {
                                  height: '56px',
                                  fontSize: '16px',
                                  backgroundColor: 'white',
                                  color: 'black',
                                  minWidth: '150px',
                                  width: '100%'
                                }
                              }}
                              inputProps={{
                                style: {
                                  color: 'black',
                                  fontSize: '16px',
                                  width: '100%'
                                }
                              }}
                              sx={{
                                minWidth: '150px',
                                width: '100%'
                              }}
                            />
                            <IconButton size="small" onClick={handleSaveAttendanceScore}>
                              <Check fontSize="small" />
                            </IconButton>
                            <IconButton size="small" onClick={() => setEditingAttendanceScore(null)}>
                              <Close fontSize="small" />
                            </IconButton>
                          </Stack>
                        ) : (
                          <Box
                            sx={{
                              p: 1,
                              cursor: "pointer",
                              "&:hover": { bgcolor: "grey.100" },
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            onClick={() => handleEditAttendanceScore(student.id)}
                          >
                            <Typography>{attendanceScores[student.id] || "Add score..."}</Typography>
                            <Edit fontSize="small" sx={{ opacity: 0.5 }} />
                          </Box>
                        )}
                      </TableCell>
                      <TableCell sx={{ p: 0 }}>
                        {editingOverallRemark === student.id ? (
                          <Box sx={{ position: 'relative' }} ref={overallRemarkRef} key={`overall-remark-${student.id}`}>
                          <Stack direction="row" alignItems="center" sx={{ p: 1 }}>
                            <TextField
                              key={`textfield-overall-remark-${student.id}`}
                              value={editOverallRemarkValue}
                                onChange={(e) => {
                                  setEditOverallRemarkValue(e.target.value);
                                  setOverallRemarkSearch(e.target.value);
                                  setShowOverallRemarkSuggestions(true);
                                }}
                                onFocus={() => setShowOverallRemarkSuggestions(true)}
                              placeholder="Add overall remarks..."
                              fullWidth
                              variant="outlined"
                              InputProps={{
                                style: {
                                  height: '56px',
                                  fontSize: '16px',
                                  backgroundColor: 'white',
                                  color: 'black',
                                  minWidth: '150px',
                                  width: '100%'
                                }
                              }}
                              inputProps={{
                                style: {
                                  color: 'black',
                                  fontSize: '16px',
                                  width: '100%'
                                }
                              }}
                              sx={{
                                minWidth: '150px',
                                width: '100%'
                              }}
                            />
                            <IconButton size="small" onClick={handleSaveOverallRemark}>
                              <Check fontSize="small" />
                            </IconButton>
                              <IconButton size="small" onClick={() => {
                                setEditingOverallRemark(null);
                                setShowOverallRemarkSuggestions(false);
                                setOverallRemarkSearch("");
                              }}>
                              <Close fontSize="small" />
                            </IconButton>
                          </Stack>
                            {showOverallRemarkSuggestions && (
                              <Paper
                                sx={{
                                  position: 'absolute',
                                  top: '100%',
                                  left: 0,
                                  right: 0,
                                  zIndex: 1000,
                                  maxHeight: 200,
                                  overflow: 'auto',
                                  boxShadow: 3,
                                  border: 1,
                                  borderColor: 'grey.300'
                                }}
                              >
                                {filteredOverallRemarkSuggestions.length > 0 ? (
                                  filteredOverallRemarkSuggestions.map((suggestion, index) => (
                                    <Box
                                      key={index}
                                      sx={{
                                        p: 1,
                                        cursor: 'pointer',
                                        borderBottom: 1,
                                        borderColor: 'grey.200',
                                        '&:hover': { bgcolor: 'grey.100' },
                                        '&:last-child': { borderBottom: 0 }
                                      }}
                                      onClick={() => handleOverallRemarkSuggestionClick(suggestion)}
                                    >
                                      <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                        {suggestion}
                                      </Typography>
                                    </Box>
                                  ))
                                ) : (
                                  <Box sx={{ p: 1, textAlign: 'center' }}>
                                    <Typography variant="body2" color="text.secondary">
                                      No suggestions found
                                    </Typography>
                                  </Box>
                                )}
                              </Paper>
                            )}
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              p: 1,
                              cursor: "pointer",
                              "&:hover": { bgcolor: "grey.100" },
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            onClick={() => handleEditOverallRemark(student.id)}
                          >
                            <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                              {overallRemarks[student.id] || "Add remarks..."}
                            </Typography>
                            <Edit fontSize="small" sx={{ opacity: 0.5 }} />
                          </Box>
                        )}
                      </TableCell>
                      <TableCell>
                        <Button variant="outlined" size="small" onClick={() => handleOpenDomainModal(student.id)}>
                          Domain
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {filteredStudents.length === 0 && (
              <Typography align="center" sx={{ py: 4, color: "text.secondary" }}>
                No students match your search
              </Typography>
            )}
          </Box>
        )}

        {subjects.map(
          (subject) =>
            activeSubject === subject.id && (
              <Box key={subject.id}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                  <Search fontSize="small" color="action" />
                  <TextField
                    placeholder="Search students..."
                    value={studentFilter}
                    onChange={(e) => setStudentFilter(e.target.value)}
                    size="small"
                    sx={{ maxWidth: 300 }}
                  />
                </Stack>
                <TableContainer component={Paper}>
                  <Table sx={{ border: 1, borderColor: "grey.300" }}>
                    <TableHead sx={{ position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 10 }}>
                      <TableRow>
                        <TableCell sx={{ bgcolor: "grey.200", position: "sticky", left: 0, zIndex: 20 }}>
                          Student
                        </TableCell>
                        {isSpecialExamSubject(subject.id) ? (
                          // Special Exam: Show only Special Exams column
                          <TableCell sx={{ bgcolor: "grey.200" }} align="right">
                            Special Exams
                          </TableCell>
                        ) : (
                          // Regular Subject: Show assessment columns and score columns
                          <>
                        {visibleColumns.map((column) => (
                          <TableCell key={column.id} sx={{ minWidth: 120 }}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                              <Typography variant="body2" fontWeight="medium">
                                {column.name}
                              </Typography>
                              <IconButton size="small" onClick={() => handleRemoveColumn(column.id)}>
                                <Close fontSize="small" />
                              </IconButton>
                            </Stack>
                            <Typography variant="caption" color="text.secondary" sx={{ textTransform: "capitalize" }}>
                              {column.type === "assess toddlers" ? "Assess toddlers (for improvement)" : column.type}
                            </Typography>
                          </TableCell>
                        ))}
                        <TableCell sx={{ bgcolor: "grey.200" }} align="right">
                          Class Score
                        </TableCell>
                        <TableCell sx={{ bgcolor: "grey.200" }} align="right">
                          Exam Score
                        </TableCell>
                        <TableCell sx={{ bgcolor: "grey.200" }} align="right">
                          Total Score
                        </TableCell>
                        <TableCell sx={{ bgcolor: "grey.200" }}>Position</TableCell>
                        <TableCell sx={{ bgcolor: "grey.200" }}>Grade Type</TableCell>
                        <TableCell sx={{ bgcolor: "grey.200" }}>Grade Point</TableCell>
                        <TableCell sx={{ bgcolor: "grey.200" }}>Remarks</TableCell>
                          </>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredStudents.map((student) => (
                        <TableRow key={`${student.id}-${subject.id}`}>
                          <TableCell sx={{ fontWeight: "medium", position: "sticky", left: 0, bgcolor: "background.paper" }}>
                            {student.name}
                          </TableCell>
                          {isSpecialExamSubject(subject.id) ? (
                            // Special Exam: Show only Special Exams cell
                            <TableCell sx={{ p: 0 }} align="right">
                              {editingCell &&
                              editingCell.studentId === student.id &&
                              editingCell.subjectId === subject.id &&
                              editingCell.assessmentId === 'special-exam' ? (
                                <Stack direction="row" alignItems="center" sx={{ p: 1 }}>
                                  <TextField
                                    value={editValue}
                                    onChange={(e) => setEditValue(e.target.value)}
                                    placeholder="e.g., 30/40"
                                    size="small"
                                    sx={{ flexGrow: 1 }}
                                  />
                                  <IconButton size="small" onClick={handleSaveSpecialExam}>
                                    <Check fontSize="small" />
                                  </IconButton>
                                  <IconButton size="small" onClick={handleCancelEdit}>
                                    <Close fontSize="small" />
                                  </IconButton>
                                </Stack>
                              ) : (
                                <Box
                                  sx={{
                                    p: 1,
                                    cursor: "pointer",
                                    "&:hover": { bgcolor: "grey.100" },
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                  onClick={() => handleEditSpecialExam(student.id, subject.id)}
                                >
                                  <Typography>{getSpecialExamDisplay(student.id, subject.id)}</Typography>
                                  <Edit fontSize="small" sx={{ opacity: 0.5 }} />
                                </Box>
                              )}
                            </TableCell>
                          ) : (
                            // Regular Subject: Show assessment columns and score cells
                            <>
                          {visibleColumns.map((column) => (
                            <TableCell key={`${student.id}-${subject.id}-${column.id}`} sx={{ p: 0 }}>
                              {column.type === "assess toddlers" ? (
                                // Toddler assessment cell
                                <Box
                                  sx={{
                                    p: 1,
                                    cursor: "pointer",
                                    "&:hover": { bgcolor: "grey.100" },
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                  onClick={() => handleToddlerAssessment(student.id, subject.id, column.id)}
                                >
                                  <Typography>{getToddlerAssessmentDisplay(student.id, subject.id, column.id)}</Typography>
                                  <Edit fontSize="small" sx={{ opacity: 0.5 }} />
                                </Box>
                              ) : (
                                // Regular assessment cell
                                editingCell &&
                              editingCell.studentId === student.id &&
                              editingCell.subjectId === subject.id &&
                              editingCell.assessmentId === column.id ? (
                                <Stack direction="row" alignItems="center" sx={{ p: 1 }}>
                                  <TextField
                                    value={editValue}
                                    onChange={(e) => setEditValue(e.target.value)}
                                    placeholder="e.g., 25/30"
                                    size="small"
                                    sx={{ flexGrow: 1 }}
                                  />
                                  <IconButton size="small" onClick={handleSaveCell}>
                                    <Check fontSize="small" />
                                  </IconButton>
                                  <IconButton size="small" onClick={handleCancelEdit}>
                                    <Close fontSize="small" />
                                  </IconButton>
                                </Stack>
                              ) : (
                                <Box
                                  sx={{
                                    p: 1,
                                    cursor: "pointer",
                                    "&:hover": { bgcolor: "grey.100" },
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                  onClick={() => handleEditCell(student.id, subject.id, column.id)}
                                >
                                  <Typography>{getScoreDisplay(student.id, subject.id, column.id)}</Typography>
                                  <Edit fontSize="small" sx={{ opacity: 0.5 }} />
                                </Box>
                                )
                              )}
                            </TableCell>
                          ))}
                          <TableCell sx={{ fontWeight: "medium" }} align="right">
                            {calculateClassScore(student.id, subject.id).toFixed(2)}
                          </TableCell>
                          <TableCell sx={{ fontWeight: "medium" }} align="right">
                            {calculateExamScore(student.id, subject.id).toFixed(2)}
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }} align="right">
                            {calculateTotalScore(student.id, subject.id).toFixed(2)}
                          </TableCell>
                          <TableCell>
                            {calculateExamScore(student.id, subject.id) > 0
                              ? calculatePosition(student.id, subject.id)
                              : "-"}
                          </TableCell>
                          <TableCell>
                            {calculateTotalScore(student.id, subject.id) > 0 && (
                              <Typography variant="body2" fontWeight="medium">
                                {determineGrade(calculateTotalScore(student.id, subject.id))}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            {calculateTotalScore(student.id, subject.id) > 0 && (
                              <Typography variant="body2" fontWeight="medium">
                                {determineGradepoint(calculateTotalScore(student.id, subject.id))}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            {calculateTotalScore(student.id, subject.id) > 0 && (
                              (() => {
                                const gradeType = determineGrade(calculateTotalScore(student.id, subject.id));
                                const gradeRange = gradingScales.find(range => range.gradeType === gradeType);
                                if (!gradeRange) return <Typography variant="body2">-</Typography>;
                                
                                return (
                              <Chip
                                    label={gradeRange.remarks}
                                color={
                                      gradeRange.color.includes("success")
                                    ? "success"
                                        : gradeRange.color.includes("info")
                                    ? "info"
                                        : gradeRange.color.includes("primary")
                                    ? "primary"
                                        : gradeRange.color.includes("warning")
                                    ? "warning"
                                    : "error"
                              }
                              variant="outlined"
                                size="small"
                              sx={{
                                      fontWeight: "medium",
                                      fontSize: "0.75rem",
                                      minWidth: "60px"
                                    }}
                                  />
                                );
                              })()
                          )}
                        </TableCell>
                            </>
                          )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {filteredStudents.length === 0 && (
                <Typography align="center" sx={{ py: 4, color: "text.secondary" }}>
                  No students match your search
                </Typography>
              )}
            </Box>
          )
        )}

        {assessmentColumns.length === 0 && (
          <Typography align="center" sx={{ py: 4, color: "text.secondary" }}>
            Click "Add Assessment Column" to get started
          </Typography>
        )}

        <Paper sx={{ p: 2, mt: 4 }}>
          <Typography variant="subtitle1" gutterBottom>
            Submit Data
          </Typography>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
            <FormLabel htmlFor="term">Select {terminology}:</FormLabel>
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>{terminology}</InputLabel>
              <Select
                value={activeTerm}
                onChange={(e) => handleTermChange(e.target.value)}
                label={terminology}
              >
                {termOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Button
            variant="contained"
            onClick={handleSubmitData}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit Data"}
          </Button>
          {submitSuccess !== null && (
            <Alert
              severity={submitSuccess ? "success" : "error"}
              sx={{ mt: 2 }}
            >
              {submitMessage}
            </Alert>
          )}
        </Paper>

        <Box sx={{ mt: 4, pt: 3, borderTop: 1, borderColor: "grey.300" }}>

           
        </Box>

        <Dialog open={domainModal.open} onClose={handleCloseDomainModal} maxWidth="md" fullWidth>
          <DialogTitle>Domain Assessment</DialogTitle>
          <DialogContent>
            <Typography variant="h6" sx={{ mt: 1 }}>Affective Domain</Typography>
            {affectiveTraits.map(trait => (
              <Box key={trait} sx={{ display: 'flex', alignItems: 'center', my: 1 }}>
                <Box sx={{ minWidth: 250 }}>{trait}</Box>
                <RadioGroup
                  row
                  value={domainRatings[domainModal.studentId || '']?.affective[trait] ?? 3}
                  onChange={e => handleDomainRatingChange('affective', trait, Number(e.target.value))}
                >
                  {[5, 4, 3, 2, 1].map(val => (
                    <FormControlLabel key={val} value={val} control={<Radio />} label={val} />
                  ))}
                </RadioGroup>
              </Box>
            ))}
            <Typography variant="h6" sx={{ mt: 3 }}>Psychomotor Domain</Typography>
            {psychomotorSkills.map(skill => (
              <Box key={skill} sx={{ display: 'flex', alignItems: 'center', my: 1 }}>
                <Box sx={{ minWidth: 250 }}>{skill}</Box>
                <RadioGroup
                  row
                  value={domainRatings[domainModal.studentId || '']?.psychomotor[skill] ?? 3}
                  onChange={e => handleDomainRatingChange('psychomotor', skill, Number(e.target.value))}
                >
                  {[5, 4, 3, 2, 1].map(val => (
                    <FormControlLabel key={val} value={val} control={<Radio />} label={val} />
                  ))}
                </RadioGroup>
              </Box>
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDomainModal}>Cancel</Button>
            <Button onClick={handleSaveDomainModal} variant="contained">Save</Button>
          </DialogActions>
        </Dialog>

        <Dialog 
          open={toddlerAssessmentModal.open} 
          onClose={() => setToddlerAssessmentModal({ open: false, studentId: null, subjectId: null, assessmentId: null })}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>Toddler Assessment</DialogTitle>
          <DialogContent>
            <Grid container spacing={3} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Rating Scale
                </Typography>
                <RadioGroup
                  value={toddlerAssessmentData.rating}
                  onChange={(e) => setToddlerAssessmentData(prev => ({
                    ...prev,
                    rating: e.target.value as ToddlerRating
                  }))}
                >
                  {toddlerRatingOptions.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio />}
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Box
                            sx={{
                              width: 16,
                              height: 16,
                              borderRadius: 1,
                              bgcolor: option.color,
                              mr: 1,
                            }}
                          />
                          <Box>
                            <Typography variant="body2" fontWeight="medium">
                              {option.label}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {option.description}
                            </Typography>
                          </Box>
                        </Box>
                      }
                    />
                  ))}
                </RadioGroup>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Developmental Category
                </Typography>
                <FormControl fullWidth>
                  <InputLabel>Select Category</InputLabel>
                  <Select
                    value={toddlerAssessmentData.category || ""}
                    onChange={(e) => setToddlerAssessmentData(prev => ({
                      ...prev,
                      category: e.target.value
                    }))}
                    label="Select Category"
                  >
                    <MenuItem value="">None</MenuItem>
                    {Object.keys(toddlerMilestones).map((category) => (
                      <MenuItem key={category} value={category}>
                        {category}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Developmental Milestone (Optional)
                </Typography>
                <FormControl fullWidth>
                  <InputLabel>Select Milestone</InputLabel>
                  <Select
                    value={toddlerAssessmentData.milestone || ""}
                    onChange={(e) => setToddlerAssessmentData(prev => ({
                      ...prev,
                      milestone: e.target.value
                    }))}
                    label="Select Milestone"
                    disabled={!toddlerAssessmentData.category}
                  >
                    <MenuItem value="">None</MenuItem>
                    {toddlerAssessmentData.category && toddlerMilestones[toddlerAssessmentData.category as keyof typeof toddlerMilestones]?.map((milestone) => (
                      <MenuItem key={milestone} value={milestone}>
                        {milestone}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Observational Notes
                </Typography>
                <Box sx={{ position: 'relative' }} ref={observationalNotesRef} key="observational-notes-box">
                  <TextField
                    key="observational-notes-textfield"
                    fullWidth
                    multiline
                    rows={4}
                    value={toddlerAssessmentData.notes || ""}
                    onChange={(e) => {
                      setToddlerAssessmentData(prev => ({
                        ...prev,
                        notes: e.target.value
                      }));
                      setObservationalNotesSearch(e.target.value);
                      setShowObservationalNotesSuggestions(true);
                    }}
                    onFocus={() => {
                      setShowObservationalNotesSuggestions(true);
                      // Show all suggestions when focused, even without typing
                      if (!observationalNotesSearch.trim()) {
                        setObservationalNotesSearch(" ");
                      }
                    }}
                    placeholder="Add your detailed observations about the child's behavior, progress, strengths, areas for improvement, or any specific notes... (Click to see suggestions)"
                    variant="outlined"
                  />
                  {showObservationalNotesSuggestions && (
                    <Paper
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        maxHeight: 300,
                        overflow: 'auto',
                        boxShadow: 3,
                        border: 1,
                        borderColor: 'grey.300'
                      }}
                    >
                      {filteredObservationalNotes.length > 0 ? (
                        !observationalNotesSearch.trim() || observationalNotesSearch === " " ? (
                          // Show categorized suggestions when no search term
                          Object.entries(toddlerObservationalNotes).map(([category, notes]) => (
                            <Box key={category}>
                              <Box
                                sx={{
                                  p: 1,
                                  bgcolor: 'grey.100',
                                  borderBottom: 1,
                                  borderColor: 'grey.300'
                                }}
                              >
                                <Typography variant="subtitle2" fontWeight="medium" color="primary">
                                  {category}
                                </Typography>
                              </Box>
                              {notes.map((suggestion, index) => (
                                <Box
                                  key={`${category}-${index}`}
                                  sx={{
                                    p: 1,
                                    cursor: 'pointer',
                                    borderBottom: 1,
                                    borderColor: 'grey.200',
                                    '&:hover': { bgcolor: 'grey.50' },
                                    pl: 2
                                  }}
                                  onClick={() => handleObservationalNoteSuggestionClick(suggestion)}
                                >
                                  <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                    {suggestion}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>
                          ))
                        ) : (
                          // Show filtered suggestions when searching
                          filteredObservationalNotes.map((suggestion, index) => (
                            <Box
                              key={index}
                              sx={{
                                p: 1,
                                cursor: 'pointer',
                                borderBottom: 1,
                                borderColor: 'grey.200',
                                '&:hover': { bgcolor: 'grey.100' },
                                '&:last-child': { borderBottom: 0 }
                              }}
                              onClick={() => handleObservationalNoteSuggestionClick(suggestion)}
                            >
                              <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                {suggestion}
                              </Typography>
                            </Box>
                          ))
                        )
                      ) : (
                        <Box sx={{ p: 1, textAlign: 'center' }}>
                          <Typography variant="body2" color="text.secondary">
                            No suggestions found
                          </Typography>
                        </Box>
                      )}
                    </Paper>
                  )}
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                  Click the field to see all predefined observational notes suggestions. Type to filter suggestions. You can also write custom notes.
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setToddlerAssessmentModal({ open: false, studentId: null, subjectId: null, assessmentId: null })}>
              Cancel
            </Button>
            <Button onClick={handleSaveToddlerAssessment} variant="contained">
              Save Assessment
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}